import {Component, OnInit, AfterViewInit, Output, EventEmitter, Input, ChangeDetectorRef, OnDestroy, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {IAlternateSecurities} from "@irb/irb-editors/irb-editors.model";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {IEvent} from "@irb-common/events";
import {AppService} from "@irb/app.service";
import {Subscription} from "rxjs";
import {AbstractControl, FormControl, Validators} from "@angular/forms";
import {TooltipService} from "@irb-common/components/tooltip/tooltip.service";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
    selector: 'irb-security-restrictions',
    templateUrl: './security-restrictions.component.html',
    styleUrls: ['./security-restrictions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SecurityRestrictionsComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("restrictionTypesDropdown") restrictionTypesDropdown: any;
    @ViewChild("actionsToTakeDropdown") actionsToTakeDropdown: any;
    @ViewChild("alternativeSecuritiesDropdown") alternativeSecuritiesDropdown: any;

    //actionToTakeFormControl: FormControl = new FormControl();
    //alternateSymbolFormControl: FormControl = new FormControl();
    actionToTakeTooltipMessage = "";
    alternateSymbolTooltipMessage = "";
    _securityRestrictionsData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };
    private eventSubscription: Subscription;
    private _isDataLoaded = false;
    alternateSecuritySelectedInitial: any;
    restrictionTypeSelectedInitial: any;
    actionToTakeSelectedInitial: any;
    alternativeSecurities: Array<IDropdownItem> = [];
    alternateSecurityPlaceHolder = "";
    restrictionActionToTakePlaceHolder = "";
    restrictionTypePlaceHolder = "";
    selectedRestrictionType: IDropdownItem;
    selectedActionToTake: IDropdownItem;
    selectedAltSecurity: IDropdownItem;
    enableActionsToTake: boolean = false;
    enableSecuritySymbol: boolean = false;
    addNewSecurityItem: any = {
        button: 'Add new security',
        type: 'security',
        fromComp: 'SecurityRestrictionsComponent'
    };

    restrictionTypes: Array<IDropdownItem> = [
        {
            "value": 'NEVER_SELL',
            "name": 'Never Sell'
        }, {
            "value": 'NO_RESTRICTION',
            "name": 'No restriction'
        }, {
            "value": 'UN_MANAGED',
            "name": 'Exclude'
        }, {
            "value": 'NEVER_BUY',
            "name": 'Never Buy'
        }, {
            "value": 'NEVER_BUY_AND_SELL',
            "name": 'Never Buy and Never Sell'
        }];

    actionsToTake: Array<IDropdownItem> = [
        {
            "value": "Leave in cash",
            "name": "Leave in cash"
        }, {
            "value": "Buy an alternate security",
            "name": "Buy an alternate security"
        }, {
            "value": "Pro-rate across other model securities",
            "name": "Pro-rate across other model securities"
        }
    ];

    @Output()
    restrictionChanged: EventEmitter<{ sellingTreatment: any, conditions: any, altSecurity: IDropdownItem }> = new EventEmitter<{ sellingTreatment: any, conditions: any, altSecurity: IDropdownItem }>();

    @Input()
    set securityRestrictionsData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._securityRestrictionsData = value;
        this.selectedRestrictionType = null;
        this.selectedActionToTake = null;
        this.selectedAltSecurity = null;
        this.alternateSecuritySelectedInitial = null;
        this.restrictionTypeSelectedInitial = null;
        this.actionToTakeSelectedInitial = null;
        this.restrictionTypePlaceHolder = "";
        this.restrictionActionToTakePlaceHolder = "";
        this.alternateSecurityPlaceHolder = "";
        //this.loadData();
    }

    constructor(private irbEditorsService: IrbEditorsService, private utilService: UtilityService,
                private as: AppService, private cdr: ChangeDetectorRef, private tts: TooltipService) {
    }

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });        
    }

    ngAfterViewInit() {
        this.irbEditorsService.getMinSubAlternatives().subscribe((securityAlternatives: IAlternateSecurities) => {
            securityAlternatives.items.forEach((item: any) => {
                 this.alternativeSecurities.push({
                     name: item.securitySymbol,
                     value: item.securityId
                 } as IDropdownItem);
             });

             this.utilService.sortByKey(this.alternativeSecurities, "name", "asc");
             this.loadData();
         });
    }

    private processEvent(event: IEvent) {
        switch (event.type) {
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                if (event.data) {
                    if (event.data.editSecurity === true) {
                        this.addNewlyCreatedSecurity(event);
                    }
                    if (event.data.type === 'security' && event.data.fromComp === 'SecurityRestrictionsComponent') {
                        this.resetSecuritySearch(event)
                    }
                }
                break;
        }
    }

    private setAlternateSecurity() {
        if (this._securityRestrictionsData && this._securityRestrictionsData.multipleSecurity) {
            this.alternateSecuritySelectedInitial = this.getInitialValue("altSecurityId", this._securityRestrictionsData.securityData);
            this.alternateSecurityPlaceHolder = this.alternateSecuritySelectedInitial === 'Various' ? this.alternateSecuritySelectedInitial : "";
            let altSelected;
            if (this.alternateSecuritySelectedInitial !== 'Various') {
                altSelected = this.alternativeSecurities
                    .find(x => x.value === this.alternateSecuritySelectedInitial);
                this.selectedAltSecurity = altSelected;
            } else {
                altSelected = this.alternativeSecurities
                    .find(x => x.value === 0);
                this.selectedAltSecurity = altSelected;
            }

        } else {
            this.alternateSecuritySelectedInitial = this._securityRestrictionsData.securityData[0].altSecurityId;
            if (this.alternativeSecurities && this.alternativeSecurities.length > 0
                && this.selectedActionToTake && this.selectedActionToTake.value === "Buy an alternate security") {
                const altSelected = this.alternativeSecurities
                    .find(x => x.value === this.alternateSecuritySelectedInitial);
                this.selectedAltSecurity = altSelected;
                this.alternateSecurityPlaceHolder = "";
            } else {
                this.selectedAltSecurity = null;
                this.alternateSecurityPlaceHolder = "N/A";
            }
        }

        this.alternativeSecuritiesDropdown.setValue(this.selectedAltSecurity);
        // this.setToolTipMessages();
        this.enableDisableDropdowns();
    }

    private loadData() {
        if (this._securityRestrictionsData) {
            if (this._securityRestrictionsData.multipleSecurity) {
                this.loadMultipleSecurity();
            } else {
                this.loadSingleSecurity();
            }
            this.setAlternateSecurity();
            this._isDataLoaded = true;
            //this.initializeFormStructure();
        }
    }

    private loadSingleSecurity() {
        this.restrictionTypeSelectedInitial = this._securityRestrictionsData.securityData[0].sellingTreatment;
        if (this.restrictionTypeSelectedInitial) {
            this.selectedRestrictionType = this.restrictionTypes.find(x => x.value === this.restrictionTypeSelectedInitial);
        } else {
            this.selectedRestrictionType = null;
        }

        this.actionToTakeSelectedInitial = this._securityRestrictionsData.securityData[0].conditions;
        if (this.actionToTakeSelectedInitial) {
            this.selectedActionToTake = this.actionsToTake.find(x => x.value === this.actionToTakeSelectedInitial);
        } else {
            this.selectedActionToTake = null;
        }

        // action to take placeholder for single security.
        if (this.selectedRestrictionType &&
            (this.selectedRestrictionType.value === "NEVER_BUY" || this.selectedRestrictionType.value === "NEVER_BUY_AND_SELL")) {
            this.restrictionActionToTakePlaceHolder = "";
        } else {
            this.restrictionActionToTakePlaceHolder = "N/A";
        }

        this.restrictionTypesDropdown.setValue(this.selectedRestrictionType);
        this.actionsToTakeDropdown.setValue(this.selectedActionToTake);
    }

    private loadMultipleSecurity() {
        this.selectedRestrictionType = null;
        this.selectedActionToTake = null;
        let initialRestrictionType = this.getInitialValue("sellingTreatment", this._securityRestrictionsData.securityData);
        this.restrictionTypePlaceHolder = initialRestrictionType === 'Various' ? initialRestrictionType : '';
        if (initialRestrictionType !== 'Various') {
            this.selectedRestrictionType = this.restrictionTypes.find(x => x.value === initialRestrictionType);
        } else {
            this.selectedRestrictionType = null;
        }
        let initialActionToTake = this.getInitialValue("conditions", this._securityRestrictionsData.securityData);
        if (initialActionToTake !== 'Various') {
            this.selectedActionToTake = this.actionsToTake.find(x => x.value === initialActionToTake);
        } else {
            this.selectedActionToTake = null;
        }
        this.restrictionActionToTakePlaceHolder = initialRestrictionType === 'Various' ? initialRestrictionType : '';

    }

    private getInitialValue(name: string, items: any[]) {
        let inputVal = items[0][name];
        for (let i = 0; i < items.length; i++) {
            let thisVal = items[i][name];
            if (inputVal != thisVal) {
                inputVal = "Various";
            }
        }
        return inputVal;
    }

    onRestrictionTypeChanged() {
       // console.log('Restriction Type  changed in Restrictions', this.selectedRestrictionType);
        this.selectedActionToTake = null;
        this.selectedAltSecurity = null;

        if (this.selectedRestrictionType.value === "NEVER_BUY" || this.selectedRestrictionType.value === "NEVER_BUY_AND_SELL") {
            this.enableActionsToTake = true;
            this.selectedActionToTake = this.actionsToTake.find(x=>x.value === 'Leave in cash');
        } else {
            this.enableActionsToTake = false;
            this.selectedActionToTake = null;
        }

        this.enableSecuritySymbol = false;
        
        if (!this.enableActionsToTake) {
            this.restrictionActionToTakePlaceHolder = "N/A";
            //this.alternateSecurityPlaceHolder = "N/A";
        } else {
            this.restrictionActionToTakePlaceHolder = "";
            //this.alternateSecurityPlaceHolder = "";
        }

        this.actionsToTakeDropdown.setValue(this.selectedActionToTake);
        this.alternativeSecuritiesDropdown.setValue(null);


        this.actionsToTakeDropdown.setDisabled(!this.enableActionsToTake);
        this.alternativeSecuritiesDropdown.setDisabled(!this.enableSecuritySymbol);
        this.onActionToTakeChanged();
        //this.raiseRestrictionChangedEvent();
    }

    onActionToTakeChanged() {
       // console.log('Action To Take changed in Restrictions', this.selectedActionToTake);
        this.selectedAltSecurity = null;
        if (this.selectedActionToTake && this.selectedActionToTake.value === "Buy an alternate security") {
            this.enableSecuritySymbol = true;
            this.alternateSecurityPlaceHolder = "-Search-";
        } else {
            this.enableSecuritySymbol = false;
            this.alternateSecurityPlaceHolder = "N/A";
        }

        this.setToolTipMessages();
        this.alternativeSecuritiesDropdown.setValue(null);
        this.alternativeSecuritiesDropdown.setDisabled(!this.enableSecuritySymbol);
        this.onAlternateSecuritySymbolChanged();
        //this.raiseRestrictionChangedEvent();
    }

    onAlternateSecuritySymbolChanged() {
        this.setToolTipMessages();
        this.raiseRestrictionChangedEvent();
    }

    private getRestrictionChangedEventData() {
        const eventData: { sellingTreatment: any, conditions: any, altSecurity: IDropdownItem } = {
            sellingTreatment: null,
            conditions: null,
            altSecurity: null
        };

        if (this.selectedRestrictionType && this.selectedRestrictionType.value) {
            eventData.sellingTreatment = this.selectedRestrictionType.value;
        } else {
            eventData.sellingTreatment = "";
        }

        if (this.selectedRestrictionType && this.selectedRestrictionType.value
            && this.selectedActionToTake && this.selectedActionToTake.value) {
            eventData.conditions = this.selectedActionToTake.value;
        } else {
            eventData.conditions = "";
        }

        if (this.selectedRestrictionType && this.selectedRestrictionType.value
            && this.selectedActionToTake && this.selectedActionToTake.value && this.selectedActionToTake.value === "Buy an alternate security"
            && this.selectedAltSecurity && this.selectedAltSecurity.value !== 0) {
            eventData.altSecurity = this.selectedAltSecurity;
        } else {
            eventData.altSecurity = null;
        }

        return eventData;
    }

    private enableDisableDropdowns() {
        if (this.selectedRestrictionType &&
            (this.selectedRestrictionType.value === "NEVER_BUY" || this.selectedRestrictionType.value === "NEVER_BUY_AND_SELL")) {
            this.enableActionsToTake = true;
        } else {
            this.enableActionsToTake = false;
        }

        if (this.selectedActionToTake && this.selectedActionToTake.value === "Buy an alternate security") {
            this.enableSecuritySymbol = true;
        } else {
            this.enableSecuritySymbol = false;
        }
        
        this.actionsToTakeDropdown.setDisabled(!this.enableActionsToTake);
        this.alternativeSecuritiesDropdown.setDisabled(!this.enableSecuritySymbol);
    }


    onCreateNewSecurity() {
        const dataParam: any = {
            editSecurity: true,
            editSecurityRestrictionAltSymbol: true
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    addNewlyCreatedSecurity(event: IEvent) {
        const newData = event.data;
        const alternativeSecurities: Array<IDropdownItem> = [];

        if (newData.securities && newData.securities.responseData && newData.securities.responseData.length !== 0) {
            let newSecurityItem: any;
            newData.securities.responseData.forEach((item: any) => {
                newSecurityItem = this.buildAlternativeSecurityItem(item);
                alternativeSecurities.push(newSecurityItem);
            });

            if (alternativeSecurities && alternativeSecurities.length > 0) {
                let newConsolidatedAlternatives: Array<IDropdownItem> = [];

                if (this.alternativeSecurities?.length > 0) {
                    newConsolidatedAlternatives.push(...this.alternativeSecurities);
                }

                newConsolidatedAlternatives.push(...alternativeSecurities);
                const noneItemIndex = newConsolidatedAlternatives.findIndex(x => x.value === 0);
                
                if (noneItemIndex >= 0) {
                    newConsolidatedAlternatives.splice(noneItemIndex, 1);
                }
                
                newConsolidatedAlternatives = this.utilService.sortByKey(newConsolidatedAlternatives, "securitySymbol", "asc");
                newConsolidatedAlternatives.unshift({
                    name: "None",
                    value: 0
                } as IDropdownItem);

                this.alternativeSecurities = newConsolidatedAlternatives;
                
                if (event.data && event.data.editSecurity && event.data.editSecurityRestrictionAltSymbol === true) {
                    if (alternativeSecurities && alternativeSecurities.length === 1) {
                        const selectedSecurity = this.alternativeSecurities.find(x => x.value === alternativeSecurities[0].value);
                        this.selectedAltSecurity = selectedSecurity;
                        this.onAlternateSecurityAdded();
                    } else {
                        const selectedSecurity = this.alternativeSecurities.find(x => x.value === this.selectedAltSecurity.value);
                        this.selectedAltSecurity = selectedSecurity;
                    }
                } else {
                    if (this.alternativeSecurities && this.selectedAltSecurity) {
                        const selectedSecurity = this.alternativeSecurities.find(x => x.value === this.selectedAltSecurity.value);
                        this.selectedAltSecurity = selectedSecurity;
                    }
                }

                this.cdr.detectChanges();
            }
        }
    }

    private buildAlternativeSecurityItem(response: any) {
        const newAlternateSecurity: IDropdownItem = {
            value: response.securityId,
            name: response.securitySymbol,
        };

        return newAlternateSecurity;
    }

    onAlternateSecurityAdded() {
        const eventData = this.getRestrictionChangedEventData();
        this.restrictionChanged.emit(eventData);
    }

    ngOnDestroy(): void {
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
        }
    }

    requiredActionToTakeValidatorFn(control: AbstractControl): { [key: string]: any } | null {
       // console.log('Action To Take Validator', control);
        if (this.selectedRestrictionType && this.selectedRestrictionType.value &&
            (this.selectedRestrictionType.value === "NEVER_BUY" || this.selectedRestrictionType.value === "NEVER_BUY_AND_SELL")
            && (control?.value?.value === undefined
                || control?.value?.value === null
                || control?.value?.value === '')
        ) {
            return {'requiredActionToTake': true};
        } else {
            return null;
        }

    }

    requiredAlternateSymbolValidatorFn(control: AbstractControl): { [key: string]: any } | null {

        if (this.selectedActionToTake && this.selectedActionToTake.value &&
            (this.selectedActionToTake.value === "Buy an alternate security")
            && (control?.value === undefined
                || control?.value?.securityId === undefined
                || control?.value?.securityId === null
                || control.value?.securityId === ''
                || control.value?.securityId === '0'
                || control.value?.securityId === 0)
        ) {
            return {'requiredAlternateSymbol': true};
        } else {
            return null;
        }

    }

    setToolTipMessages() {

        if (this.selectedActionToTake?.value === 'Buy an alternate security' && !this.selectedAltSecurity) {
            this.alternateSymbolTooltipMessage = "Please select symbol";
        } else {
            this.alternateSymbolTooltipMessage = "";
        }
    }

    raiseRestrictionChangedEvent() {

        if (this.isValid()) {
            const eventData = this.getRestrictionChangedEventData();
            this.restrictionChanged.emit(eventData);
        }
    }

    isValid() {
        let isValid = true;
        isValid = (this.selectedActionToTake?.value === 'Buy an alternate security' && !this.selectedAltSecurity) ? false : true;
        return isValid;
    }

    getItemsForRestrictionTypesDropdown(searchStr: any) {
        this.restrictionTypesDropdown.set(DropdownFilterComponent.getFilteredList(searchStr, this.restrictionTypes));
    }

    getItemsForActionsToTakeDropdown(searchStr: any) {
        this.actionsToTakeDropdown.set(DropdownFilterComponent.getFilteredList(searchStr, this.actionsToTake));
    }

    getItemsForAlternativeSecuritiesDropdown(searchString: string) {
        this.alternativeSecuritiesDropdown.set(DropdownFilterComponent.getFilteredList(searchString, this.alternativeSecurities));
    }

    openNewItemSecurityFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    resetSecuritySearch(event: any) {
        const dataParam: any = event.data;
        if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
            this.alternativeSecurities = this.alternativeSecurities.concat(dataParam.newItems);

            if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
                this.alternativeSecuritiesDropdown.setValue(dataParam.newItemsForDD);
                this.selectedAltSecurity = dataParam.newItemsForDD[0];
                this.onAlternateSecuritySymbolChanged();
            }
            this.irbEditorsService.getMinSubAlternatives().subscribe((securityAlternatives: IAlternateSecurities) => {
                this.alternativeSecurities = [];
                securityAlternatives.items.forEach((item: any) => {
                    this.alternativeSecurities.push({
                        name: item.securitySymbol,
                        value: item.securityId
                    } as IDropdownItem);
                });
                this.utilService.sortByKey(this.alternativeSecurities, "name", "asc");
            });
        }

    }
}
